<template>
  <div class="wrap">
    <div class="nav">
      <img
        src="../assets/img/nav/game-logo.png"
        alt=""
        srcset=""
        class="game-logo"
      />
      <div class="menu">
        <div class="filterMenu" v-for="(item, idx) in navlist" :key="idx">
          <ul class="header-nav_list" v-if="item.lang == language">
            <li
              class="header-nav_item"
              v-for="Mitem in item.list"
              :key="Mitem.id"
              @click="handleNav(Mitem)"
            >
              <img
                :src="activeIndex == Mitem.id ? Mitem.activeUrl : Mitem.url"
              />
            </li>
          </ul>
        </div>
        <div
          class="cursor"
          :class="'pay-menu-' + language"
          @click="handlePay()"
        ></div>
      </div>

      <!-- 语言切换 -->
      <div class="lang_box" @mouseover="showMenu = true"></div>

      <div class="lang_list" v-show="showMenu" @mouseleave="showMenu = false">
        <div
          v-for="(item, index) in languageList"
          :key="index"
          class="lang_item"
          :id="item.key"
          @click="changeLangEvent(item)"
        >
          <img :src="language == item.key ? item.activeUrl : item.url" />
        </div>
      </div>
    </div>

    <div class="page">
      <swiper
        :options="swiperOption"
        ref="goodSwiper"
        @slideChange="slideChange"
      >
        <swiper-slide>
          <layer1 :language="language" @handleVideo="videoFlag = true" />
        </swiper-slide>
        <!-- <swiper-slide>
          <layer2 :language="language" />
        </swiper-slide> -->
        <swiper-slide>
          <layer3
            ref="silderAudio"
            :language="language"
            :changeRoleLang="changeLang"
          />
        </swiper-slide>
        <swiper-slide>
          <layer4 :language="language" :changeLang="changeLang" />
        </swiper-slide>
        <swiper-slide id="copyright">
          <copyright :language="language" />
        </swiper-slide>
      </swiper>
    </div>

    <!-- share icon -->
    <div class="share-icon cursor">
      <div class="sns-fb icon-size" @click="facebook_page()"></div>
      <div class="sns-dc icon-size" @click="Discord_page('dc')"></div>
      <div class="sns-ytu icon-size" @click="youtube_page('yt')"></div>
      <div class="sns-twi icon-size" @click="Twitter_page('twi')"></div>
      <div class="sns-line icon-size" @click="line_page('line')"></div>
    </div>
    <!-- btn -->
    <div
      class="share-btn cursor"
      :class="activeIndex != 1 ? 'iconBlock' : 'iconNone'"
    >
      <img
        :src="require('../assets/img/nav/' + language + '/ios.png')"
        alt=""
        srcset=""
        @click="AS_reg('ios')"
      />
      <img
        :src="require('../assets/img/nav/' + language + '/gp.png')"
        alt=""
        srcset=""
        @click="GP_reg('gp')"
      />
      <img
        :src="require('../assets/img/nav/hw.png')"
        alt=""
        srcset=""
        @click="hw_down('hw')"
      />
    </div>
    <!-- 首页视频 -->
    <div
      v-if="videoFlag"
      class="model position-fixed"
      @click="videoFlag = false"
    >
      <div class="v-txt">
        <iframe
          width="100%"
          height="100%"
          :src="language == 'th' ? langTh : langEn"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import layer1 from "./publicComponents/layer1";
import layer2 from "./publicComponents/layer2";
import layer3 from "./publicComponents/layer3";
import layer4 from "./publicComponents/layer4";
import copyright from "./publicComponents/copyright";
import * as swiperAni from "../commonFunction/animate.js";

let _y = 0;
let _isEnd = false;

export default {
  components: {
    layer1,
    layer2,
    layer3,
    layer4,
    copyright
  },
  data() {
    let that = this;
    return {
      langEn: "https://www.youtube.com/embed/WpP1Ejb_NE8?si=hSiED3uDb7XQaqPy",
      langTh: "https://www.youtube.com/embed/TIIcoLrB94Y?si=F3Hy74eWrOx6Rp0t",
      // 默认语言是英语
      language: localStorage.getItem("sof_locale") || "en",
      languageList: [
        {
          id: 1,
          key: "en",
          url: require("../assets/img/nav/en-b.png"),
          activeUrl: require("../assets/img/nav/en-c.png")
        },
        {
          id: 2,
          key: "cn",
          url: require("../assets/img/nav/cn-b.png"),
          activeUrl: require("../assets/img/nav/cn-c.png")
        },
        {
          id: 3,
          key: "th",
          url: require("../assets/img/nav/th-b.png"),
          activeUrl: require("../assets/img/nav/th-c.png")
        }
      ],
      // menu
      navlist: [
        {
          lang: "en",
          list: [
            {
              id: 1,
              url: require("../assets/img/nav/en/1.png"),
              activeUrl: require("../assets/img/nav/en/1-active.png")
            },
            // {
            //   id: 2,
            //   url: require("../assets/img/nav/en/2.png"),
            //   activeUrl: require("../assets/img/nav/en/2-active.png")
            // },
            {
              id: 2,
              url: require("../assets/img/nav/en/3.png"),
              activeUrl: require("../assets/img/nav/en/3-active.png")
            },
            {
              id: 3,
              url: require("../assets/img/nav/en/4.png"),
              activeUrl: require("../assets/img/nav/en/4-active.png")
            }
            // {
            //   id: 4,
            //   url: require("../assets/img/nav/en/5.png"),
            //   activeUrl: require("../assets/img/nav/en/5-active.png")
            // }
          ]
        },
        {
          lang: "th",
          list: [
            {
              id: 1,
              url: require("../assets/img/nav/th/1.png"),
              activeUrl: require("../assets/img/nav/th/1-active.png")
            },
            // {
            //   id: 2,
            //   url: require("../assets/img/nav/th/2.png"),
            //   activeUrl: require("../assets/img/nav/th/2-active.png")
            // },
            {
              id: 2,
              url: require("../assets/img/nav/th/3.png"),
              activeUrl: require("../assets/img/nav/th/3-active.png")
            },
            {
              id: 3,
              url: require("../assets/img/nav/th/4.png"),
              activeUrl: require("../assets/img/nav/th/4-active.png")
            }
            // {
            //   id: 4,
            //   url: require("../assets/img/nav/th/5.png"),
            //   activeUrl: require("../assets/img/nav/th/5-active.png")
            // }
          ]
        },
        {
          lang: "cn",
          list: [
            {
              id: 1,
              url: require("../assets/img/nav/cn/1.png"),
              activeUrl: require("../assets/img/nav/cn/1-active.png")
            },
            // {
            //   id: 2,
            //   url: require("../assets/img/nav/cn/2.png"),
            //   activeUrl: require("../assets/img/nav/cn/2-active.png")
            // },
            {
              id: 2,
              url: require("../assets/img/nav/cn/3.png"),
              activeUrl: require("../assets/img/nav/cn/3-active.png")
            },
            {
              id: 3,
              url: require("../assets/img/nav/cn/4.png"),
              activeUrl: require("../assets/img/nav/cn/4-active.png")
            }
            // {
            //   id: 4,
            //   url: require("../assets/img/nav/cn/5.png"),
            //   activeUrl: require("../assets/img/nav/cn/5-active.png")
            // }
          ]
        }
      ],
      // swiper
      nextShow: true,
      swiperOption: {
        direction: "vertical",
        slidesPerView: "auto",
        allowTouchMove: false,
        slideToClickedSlide: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        mousewheel: true, //开启鼠标
        noSwiping: false,
        noSwipingClass: "stop-swiping",
        initialSlide: 0,
        breakpoints: {
          780: {
            allowTouchMove: true
          }
        },
        on: {
          init: function() {
            swiperAni.swiperAnimateCache(this); //隐藏动画元素
            swiperAni.swiperAnimate(this); //初始化完成开始动画
          },
          slideChangeTransitionStart: function() {
            swiperAni.swiperAnimate(this); //每个slide开始切换时也运行当前slide动画
            //this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); 动画只展现一次，去除ani类名
          }
        }
      },

      activeIndex: 1,
      // 切换语言
      showMenu: false,
      eventsAuto: false,
      changeLang: 0,
      videoFlag: false
    };
  },
  created() {},
  updated() {},

  mouthed() {},
  watch: {},
  computed: {},
  methods: {
    // 切换语言
    changeLangEvent(item) {
      this.changeLang = item.id;
      localStorage.setItem("sof_locale", item.key);
      this.$i18n.locale = localStorage.getItem("sof_locale");
      this.language = item.key;

      this.$refs.silderAudio.stopAduio();
    },
    // 菜单
    handleNav(val) {
      this.activeIndex = val.id;
      const hcon = this.$refs.goodSwiper.swiper;
      if (val.id == 1) {
        hcon.slideTo(0, 300);
      }
      if (val.id == 2) {
        hcon.slideTo(1, 300);
      }
      if (val.id == 3) {
        hcon.slideTo(2, 300);
      }
    },
    handlePay() {
      window.open(`https://sofm.ujoygames.com/pay`, "_blank");
    },
     hw_down(val){this.common.goShare(val);},
    // end~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // 预注册错误弹出框出来后，禁止页面滑动
    // changeSilderDisable() {
    //   this.$refs.goodSwiper.swiper.mousewheel.disable();
    // },
    // changeSilderEnable() {
    //   this.$refs.goodSwiper.swiper.mousewheel.enable();
    // },
    line_page(val) {
      this.common.goShare(val);
    },
    Twitter_page(val) {
      this.common.goShare(val);
    },
    Discord_page(val) {
      this.common.goShare(val);
    },
    facebook_page() {
      if (this.language == "th") {
        window.open(`https://www.facebook.com/SealofFateTH`, "_blank");
      } else {
        window.open(`https://www.facebook.com/SealofFateSEA`, "_blank");
      }
    },
    youtube_page(val) {
      this.common.goShare(val);
    },
    AS_reg(val) {
      this.common.goShare(val);
    },
    GP_reg(val) {
      this.common.goShare(val);
    },
    slideChange() {
      const mainActiveIndex = this.$refs.goodSwiper.swiper.activeIndex;
      this.activeIndex = mainActiveIndex + 1;
    }
  }
};
</script>
<style lang="scss">
.wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-repeat: no-repeat;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #000;

  #copyright {
    height: 65px;
    width: 100%;
  }

  // 轮播

  .page {
    .swiper-container {
      width: 100%;
      height: 100%;
    }
  }

  .iconNone {
    display: none;
  }
  .iconBlock {
    display: block;
  }
  .share-btn {
    position: absolute;
    right: 6vw;
    bottom: 2vw;
   

    img {
      width: 180px;
      height: auto;
        display: block;
    margin-bottom: .5vw;
    }
  }
  .share-icon {
    position: absolute;
    right: 2vw;
    top: 50%;
    transform: translate(0, -50%);

    .icon-size {
      width: 53px;
      height: 52px;
      margin-bottom: 0.8vw;
    }
    .sns-fb {
      background-image: url("../assets/img/nav/sns1-b.png");
      background-size: 100% 100%;
      &:hover {
        background-image: url("../assets/img/nav/sns1-c.png");
        background-size: 100% 100%;
      }
    }
    .sns-dc {
      background-image: url("../assets/img/nav/sns2-b.png");
      background-size: 100% 100%;
      &:hover {
        background-image: url("../assets/img/nav/sns2-c.png");
        background-size: 100% 100%;
      }
    }
    .sns-ytu {
      background-image: url("../assets/img/nav/sns3-b.png");
      background-size: 100% 100%;
      &:hover {
        background-image: url("../assets/img/nav/sns3-c.png");
        background-size: 100% 100%;
      }
    }
    .sns-twi {
      background-image: url("../assets/img/nav/sns4-b.png");
      background-size: 100% 100%;
      &:hover {
        background-image: url("../assets/img/nav/sns4-c.png");
        background-size: 100% 100%;
      }
    }
    .sns-line {
      background-image: url("../assets/img/nav/sns5-b.png");
      background-size: 100% 100%;
      &:hover {
        background-image: url("../assets/img/nav/sns5-c.png");
        background-size: 100% 100%;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .share-icon {
    top: 50% !important;
  }
}
@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .share-icon {
    top: 50% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainIndex.vue